import React from 'react';
import { Link } from 'react-router-dom';
import Seo from '../components/Seo';
import Bande from '../components/Bande';
import SectionContact from '../components/SectionContact';
import { ENTREPRISE } from '../data/site';

export default function PageIntrouvable() {
  return (
    <>
      <Seo titre="Page introuvable | BATI SELECT TP" description="Cette page n'existe pas ou a été déplacée." />
      <section className="bg-nuit text-white relative overflow-hidden">
        <div className="absolute inset-0 trame-diagonale" aria-hidden="true" />
        <div className="conteneur relative py-20 text-center">
          <h1 className="font-display uppercase text-[40px] sm:text-[56px] leading-[1]">
            Cette page a <span className="mot-degrade">disparu</span>
          </h1>
          <p className="mt-5 text-white/75 max-w-lg mx-auto text-[18px]">
            Le lien est peut-être ancien, ou l'adresse comporte une faute de frappe.
            Nos machines, elles, sont toujours là.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/nos-engins" className="btn-jaune">Voir le parc</Link>
            <a href={ENTREPRISE.telephoneLien} className="btn-contour">{ENTREPRISE.telephone}</a>
          </div>
        </div>
        <Bande hauteur={6} />
      </section>

      <SectionContact
        avant="Dites-nous plutôt ce que vous "
        mot="cherchez"
        intro="Une machine, un tonnage, une date. On vous répond en quelques heures avec ce qui correspond."
      />
    </>
  );
}
